
//import {functions} from "@/scripts/firebase"
import {getDocs,orderBy,query} from 'firebase/firestore'
//import { httpsCallable } from "firebase/functions"
import { Component, Prop, Watch,Mixins} from 'vue-property-decorator';
import { ExEventData } from "@/scripts/datatypes"
import { EventData} from "../common-datatypes"
import Common from '@/mixins/common'

type Taxonomy = {
	[key in 'class' | 'group' ]: Term[]
};

interface Term {
  name: string;
  id: string;
  count: number;
}

interface SelectedFilter {
  classId: string;
  groupId: string;
  excludeEventDocIds: string[];
  searchText: string;
}

@Component

export default class ModalSelectEvent extends Mixins(Common)  {
  @Prop({type: Array,default: () => {return []}}) private selectedEventDocIds?: string[]
  @Prop({type: Array,default: () => {return []}}) private defaultEventDocIds?: string[]
  @Prop({type: String, default: ''}) private title?: string
  @Prop({type: String, default: ''}) private defaultClassId?: string
  @Prop({type: String, default: ''}) private defaultGroupId?: string
  @Prop({type: Array,default: () => {return []}}) private excludeEventDocIds?: string[]

  isLoading = true

  isActive = true

  orderBy: keyof EventData = 'start' as string

  events: ExEventData[] = []

  cls: {classId: string; name: string}[] = []
  group: {groupId: string; name: string}[] = []

  taxonomy: Taxonomy = {
    class: [],
    group: [],
  }

  selectedFilter: SelectedFilter = {
    classId: '',
    groupId: '',
    excludeEventDocIds: [],
    searchText: '' 
  }

  getEventName(eventDocId: string){
    const theEvent = this.events.find((event) => {return event.extendedProps.docId === eventDocId})
    if(theEvent){
      return {
        name: this.$getReferenceObjectName(theEvent,'event'),
        date: theEvent.start
      }
    }
    return false
  }

  @Watch('selectedEventDocIds',{immediate: true})
  updateSelectedEventDocIds(newVal: string[]){
    this.selectedFilter.excludeEventDocIds =  Array.from(new Set(newVal.concat(this.excludeEventDocIds || [])))
  }

  @Watch('excludeEventDocIds',{immediate: true})
  updateExcludeEventDocIds(newVal: string[]){
    this.selectedFilter.excludeEventDocIds = Array.from(new Set(newVal.concat(this.selectedEventDocIds || [])))
  }

  get isStaff(){
    return !! this.$store.getters.isStaff
  }

  setFilterOnEventsData(filter: SelectedFilter){

    const settingFilter = !! (filter.classId || filter.groupId || filter.searchText || filter.excludeEventDocIds)

    this.events = this.events.map(event => {
      event.hidden = false
      const classId = event.extendedProps.classId
      const groupId = event.extendedProps.groupId

      if(! settingFilter){
        return event
      }

      if(filter.searchText && ! this.$findTextByEvent(filter.searchText, event)){
        event.hidden = true
        return event
      }

      if(filter.classId && classId !== filter.classId){
        event.hidden = true
        return event
      }

      if(filter.groupId && groupId !== filter.groupId){
        event.hidden = true
        return event
      }

      if(filter.excludeEventDocIds.length > 0 && filter.excludeEventDocIds.includes(event.extendedProps.docId || '')){
        event.hidden = true
        return event
      }

      return event
    })
  }

  @Watch('selectedFilter',{deep: true})
  changeSelectedFilter(newVal: SelectedFilter){
    console.log(newVal)
    this.setFilterOnEventsData(newVal)
  }

  setTaxonomies(){
    this.taxonomy.class = this.cls.map((cl) => {
      return {name: cl.name || '', id: cl.classId || '', count: 0}
    })

    this.taxonomy.group = this.group.map((group) => {
      return {name: group.name || '', id: group.groupId || '', count: 0}
    })
  }

  setTaxonomy(type: Term[], name: string, id = ''){
    if(! name){
      return
    }

    const findIndex = type.findIndex((term) => {
      if(id !== ''){
        return term.id === id && term.name === name
      }
      return term.name === name
    })

    const term: Term = {
      name: name,
      count: 1,
      id: id
    }

    if(findIndex === -1){
      type.push(term)
    }else{
      term.count = 1 + type[findIndex].count
      type.splice(findIndex, 1,term)
    }
  }

  async created(){
    try{
      this.isLoading = true

      const queryConstraints = [orderBy(this.orderBy as string)]//startAfter(Date.now()),
      const eventQuery = this.isStaff ? query(this.$getEventsColRef(),...queryConstraints) : query(this.$getUserEventsColRef() ,...queryConstraints)

      const eventDocs = await getDocs(eventQuery)

      this.events = eventDocs.docs.map((doc) => {
        const data = doc.data()
        const classId = data.extendedProps.classId
        const className = data.extendedProps.className

        if(classId && className && this.cls.findIndex((cl) => {return cl.classId === classId}) == -1){
          this.cls.push({classId: classId, name: className})
        }

        const groupId = data.extendedProps.groupId
        const groupName = data.extendedProps.groupName

        if(groupId && groupName && this.group.findIndex((group) => {return group.groupId === groupId}) == -1){
          this.group.push({groupId: groupId, name: groupName})
        }

        return {
          ...data,
          hidden: false,
        }
      })
      this.selectedFilter.classId = this.defaultClassId || ''
      this.selectedFilter.groupId = this.defaultGroupId || ''
      this.setTaxonomies()
      
      this.setFilterOnEventsData(this.selectedFilter)

    }catch(error){
      console.table(error)
    }finally{
      this.isLoading = false
    }
  }

  mounted(){
    //
  }

  public deselectEvent(eventDocId: string): void{
    this.$emit("onSelect", eventDocId)
  }

  public selectEvent(event: ExEventData): void{
    this.$emit("onSelect", event)
  }

}
